module.exports = __webpack_public_path__ + "static/primaryendpoint_chart_zoom-eea4d26684a45df68e5c9110eecb11fb.png";